import React from 'react'

import { useDispatch } from 'react-redux'

import { HowGoustoFoodBoxesWorkPage, MealPlanningPage } from '@features/marketing-pages'

import { applyPromoCodeAndShowModal } from 'actions/home'
import { redirect } from 'actions/redirect'

export function HowGoustoWorks() {
  const dispatch = useDispatch()

  const handleClick = async (path: string) => {
    await dispatch(applyPromoCodeAndShowModal())

    dispatch(redirect(path))
  }

  return <HowGoustoFoodBoxesWorkPage startOnboarding={handleClick} />
}

export function MealPlanning() {
  const dispatch = useDispatch()

  const handleClick = async (path: string) => {
    await dispatch(applyPromoCodeAndShowModal())

    dispatch(redirect(path))
  }

  return <MealPlanningPage startOnboarding={handleClick} />
}
